export enum PlayerSize {
  Window = 'WINDOW',
  Fullscreen = 'FULLSCREEN',
}
